import { TEST_HUB_URL } from '@/constants/constants';
import { OriginalUserDataType, UserResponse } from '@/types';
import { BSON } from 'realm-web';
import { apiFetch } from '@/utils/apiWrapper';

export const fetchCompany = async (id: BSON.ObjectID | string, outlets?: string[]) => {
  if (!id) return;
  try {
    // Fetch Company
    const response = await apiFetch(`${TEST_HUB_URL}company/${id}`);
    console.log('response', response);
    if (!response?.ok) {
      throw new Error(`Failed to fetch company: ${response?.status} ${response?.statusText}`);
    }
    const company = await response.json();

    // Fetch Customers Count without taking outlets into account
    const customerCountResponse = await apiFetch(`${TEST_HUB_URL}customer/count/${id}`);
    if (!customerCountResponse?.ok) {
      throw new Error(
        `Failed to fetch company: ${customerCountResponse?.status} ${customerCountResponse?.statusText}`,
      );
    }
    const customerCount = await customerCountResponse.json();

    // Fetch Employees Count without taking outlets into account
    const userCountResponse = await apiFetch(`${TEST_HUB_URL}user/count/${id}`);
    if (!userCountResponse?.ok) {
      throw new Error(
        `Failed to fetch company: ${userCountResponse?.status} ${userCountResponse?.statusText}`,
      );
    }
    const userCount = await userCountResponse.json();

    // Build query parameters using outlets
    const queryParams = new URLSearchParams();
    if (outlets && outlets.length > 0) {
      queryParams.append('outlets', JSON.stringify(outlets));
    }
    const queryString = queryParams.toString();

    // Fetch Product Count based on outlets
    const productCountResponse = await apiFetch(
      `${TEST_HUB_URL}product/count/${id}?${queryString}`,
    );
    if (!productCountResponse?.ok) {
      throw new Error(
        `Failed to fetch company: ${productCountResponse?.status} ${productCountResponse?.statusText}`,
      );
    }
    const productCount = await productCountResponse.json();

    // Fetch Order Count based on outlets
    const orderCountResponse = await apiFetch(`${TEST_HUB_URL}order/count/${id}?${queryString}`);
    if (!orderCountResponse?.ok) {
      throw new Error(
        `Failed to fetch company: ${orderCountResponse?.status} ${orderCountResponse?.statusText}`,
      );
    }
    const orderCount = await orderCountResponse.json();

    // Create the company object with the fetched data
    const companyWithCustomerNumber = {
      ...company,
      customers: customerCount.count ?? 0,
      products: productCount.count ?? 0,
      employees: userCount.count ?? 0,
      orders: orderCount.count ?? 0,
    };

    return companyWithCustomerNumber;
  } catch (err) {
    console.error('Error fetching company with count details', err);
    throw err; // Re-throw the error to handle it in the calling function
  }
};

export async function transformData(input: OriginalUserDataType): Promise<UserResponse> {
  let companyId = '';
  // Handle new JWT structure where companies is an array of objects
  if (input.companies && input.companies.length > 0) {
    companyId = input.companies[0]?.$oid;
  }

  return {
    _id: input._id, // Use organizationId as _id
    email: input.email,
    phone: input.phone,
    accountId: input.organizationId, // Use organizationId as accountId
    companyId: companyId,
    type: input.type,
    firstName: input.firstName,
    lastName: input.lastName,
    name: `${input.firstName} ${input.lastName}`, // Construct name from first and last
    outlets: input.outlets || [],
  };
}
